export const ThumbnailWidth = 150;
// Bounded content is limiting the size of the image to 816px. No matter how big is the screen it will not be bigger than 816px.
export const GalleryWidth = 816;
export const ZoomWidth = 1500;
